export const MIXPANEL_EVENTS = {
    ITEM_CLICKS: 'Item Clicks',
    END_SESSION_REQUEST: 'End Session Request',
    LOOK_VIEWS: 'Look Views',
    LOGIN: 'Login',
    ITEM_VIEWS: 'Item Views'
};
